module.exports = __webpack_public_path__ + "static/genesis-mock-99a3da214210360587dd8968c07daf9f.png";